import { render, staticRenderFns } from "./SelectedWord.vue?vue&type=template&id=7581d130"
import script from "./SelectedWord.vue?vue&type=script&lang=js"
export * from "./SelectedWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports